/**
 * Asynchronously loads the component for Customer
 */

import React from "react";
import loadable from "../../../utils/loadable";

export default loadable(() => import("./Solution2"), {
  fallback: <div>Loading...</div>,
});
